<template>
  <div class="menu-item">
    <div
      :class="['menu-item__title', { 'menu-item__title--active': activeItemSlug === item.slug }]"
      @click="onClickItemTitle"
    >
      <span> {{ item.label }}</span>
      <Chevron
        v-if="hasChildren"
        :is-open="isOpen"
      />
    </div>
    <div
      v-if="hasChildren && isOpen"
      class="menu-item-children"
    >
      <div
        v-for="child in props.item.children"
        :key="child.slug"
        :class="['menu-item-children__item', { 'menu-item-children__item--active': activeItemSlug === child.slug }]"
        @click="onClickChild(child.slug)"
      >
        {{ child.label }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import Chevron from './icons/Chevron.vue';
  import type { IMenuItem } from './menu.types';

  interface IProps {
    item: IMenuItem;
    routeStart: string;
    activeItemSlug?: string;
  }

  const emits = defineEmits(['close']);
  const props = defineProps<IProps>();

  const route = useRoute();
  const router = useRouter();

  const hasChildren = computed(() => !!props.item.children?.length);
  const isOpen = ref(false);
  const toggle = () => (isOpen.value = !isOpen.value);

  const onClickItemTitle = () => {
    if (hasChildren.value) {
      toggle();

      return;
    }
    if (props.item.link) {
      window.location.href = props.item.link;
      emits('close');

      return;
    }

    router.push(`${props.routeStart}/${props.item.slug}`);
    emits('close');
  };

  const onClickChild = (slug: string) => {
    router.push(`${props.routeStart}/${props.item.slug}/${slug}`);
    emits('close');
  };

  onMounted(() => {
    if (route.params.slug === props.item.slug) {
      isOpen.value = true;
    }
  });
</script>

<style scoped lang="scss">
  .menu-item__title {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;
  }

  .menu-item-children {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 8px;
    padding: 0 24px 0 8px;
    cursor: pointer;
    user-select: none;
  }

  .menu-item-children__item {
    padding: 4px 8px;
  }

  .menu-item__title--active {
    margin-left: -8px;
    padding: 4px 8px;
    border-radius: 8px;
    background-color: var(--alias-color-background-subtle);
  }

  .menu-item-children__item--active {
    border-radius: 8px;
    background-color: var(--alias-color-background-subtle);
  }
</style>
